import React from "react";
import { getPaymentReturnUrl, getQueryVariable } from "./App";
import { ResetButton } from "./ResetButton";

const getPreviewTourName = () =>
  getQueryVariable("previewTour") || "Schindler's Factory";

const getPreviewPrice = () => getQueryVariable("previewPrice") || "480";

const getPreviewTourId = () => getQueryVariable("TourId") || "preview-tour-001";

const PaymentElementPreview = () => (
  <div className="PaymentElementPreview">
    <div className="PaymentElementPreviewRow">
      <span>Card number</span>
      <strong>4242 4242 4242 4242</strong>
    </div>
    <div className="PaymentElementPreviewSplit">
      <div className="PaymentElementPreviewRow">
        <span>Expiry</span>
        <strong>12 / 34</strong>
      </div>
      <div className="PaymentElementPreviewRow">
        <span>CVC</span>
        <strong>123</strong>
      </div>
    </div>
  </div>
);

const CardPreview = () => (
  <>
    <fieldset className="FormGroup">
      <div className="CheckoutField">
        <label className="CheckoutFieldLabel">Name</label>
        <div className="CheckoutFieldSurface">
          <input
            className="CheckoutTextInput"
            value="Jane Doe"
            readOnly
            aria-label="Preview name"
          />
        </div>
      </div>
      <div className="CheckoutField">
        <label className="CheckoutFieldLabel">Email</label>
        <div className="CheckoutFieldSurface">
          <input
            className="CheckoutTextInput"
            value="janedoe@gmail.com"
            readOnly
            aria-label="Preview email"
          />
        </div>
      </div>
    </fieldset>
    <fieldset className="FormGroup">
      <div className="CheckoutField CheckoutField--card">
        <label className="CheckoutFieldLabel">Card details</label>
        <div className="CheckoutFieldSurface CheckoutFieldSurface--card">
          <PaymentElementPreview />
        </div>
      </div>
    </fieldset>
  </>
);

const MultiPreview = () => (
  <fieldset className="FormGroup">
    <div className="CheckoutField CheckoutField--card">
      <label className="CheckoutFieldLabel">Payment details</label>
      <div className="CheckoutFieldSurface CheckoutFieldSurface--card">
        <PaymentElementPreview />
      </div>
    </div>
  </fieldset>
);

export const PaymentPreviewPage = () => {
  const useMulti = getQueryVariable("UseMulti") === "1";
  const tourName = getPreviewTourName();
  const price = getPreviewPrice();
  const tourId = getPreviewTourId();

  return (
    <div className="PaymentFlowShell">
      <section className="PaymentHeroCard">
        <div className="HeroTopline">
          <span className="HeroEyebrow">Preview mode</span>
          <div className="HeroTrustPill">No live payment</div>
        </div>
        <img className="LogoImg" src="logo_poziom2_b.png" alt="GuideHub logo" />
        <div className="HeroHeadlineBlock">
          <h1 className="PaymentTitle">Preview the payment experience</h1>
          <p className="PaymentIntro">
            This local preview skips Stripe confirmation so you can review the
            layout and spacing safely.
          </p>
        </div>

        <div className="TourImageContainer">
          <div className="TourPreviewPlaceholder">
            <div className="TourPreviewPlaceholderIcon">GH</div>
            <div className="TourPreviewPlaceholderText">
              <strong>{tourName}</strong>
              <span>Preview image state</span>
            </div>
          </div>
        </div>

        <div className="PaymentOverviewCard">
          <div className="PaymentOverviewHeader">
            <div>
              <div className="PaymentOverviewLabel">Selected experience</div>
              <div className="PaymentOverviewTitle">{tourName}</div>
            </div>
            <div className="PaymentOverviewAmount">
              <span>Total</span>
              <strong>{price} PLN</strong>
            </div>
          </div>
        </div>
      </section>

      <form className="Form" onSubmit={(e) => e.preventDefault()}>
        <div className="FormCardHeader">
          <div>
            <div className="FormCardEyebrow">Preview checkout</div>
            <div className="ResultTitle" role="alert">
              Pay for your {tourName} tour
            </div>
          </div>
          <div className="FormHeaderAmount">
            <span>Total due</span>
            <strong>{price} PLN</strong>
          </div>
        </div>

        <div className="PaymentMiniSummary">
          <div className="PaymentMiniSummaryRow">
            <span>Flow type</span>
            <strong>{useMulti ? "Payment Element" : "Card checkout"}</strong>
          </div>
          <div className="PaymentMiniSummaryRow">
            <span>Booking reference</span>
            <strong>{tourId}</strong>
          </div>
        </div>

        {useMulti ? <MultiPreview /> : <CardPreview />}

        <div className="PreviewFormActions">
          <ResetButton
            onClick={() =>
              window.location.assign(
                `${getPaymentReturnUrl(tourId)}&preview=1&previewStatus=succeeded`,
              )
            }
            buttonText="Preview success"
            className="ResetButton--primary"
          />
          <ResetButton
            onClick={() =>
              window.location.assign(
                `${getPaymentReturnUrl(tourId)}&preview=1&previewStatus=processing`,
              )
            }
            buttonText="Preview processing"
            className="ResetButton--secondary"
          />
          <ResetButton
            onClick={() =>
              window.location.assign(
                `${getPaymentReturnUrl(tourId)}&preview=1&previewStatus=requires_payment_method`,
              )
            }
            buttonText="Preview failure"
            className="ResetButton--secondary"
          />
        </div>

        <div className="PaymentGuarantee">
          <p>Preview mode does not contact Stripe or complete any payment.</p>
          <p>Use it to review checkout, success, and failure layouts locally.</p>
        </div>
      </form>
    </div>
  );
};

export default PaymentPreviewPage;
